<div class="chip-container" fxLayout="column" fxLayoutGap.gt-sm="10px">
    <mat-form-field class="search-box" appearance="fill">
        <mat-label i18n>User name or email </mat-label>
        <input matInput #search placeholder="Search by name or email" i18n-placeholder [formControl]="control" />
    </mat-form-field>
    <h4 *ngIf="source?.length" class="filter-header" i18n="@@chooseUser">Choose user</h4>
    <mat-chip-list
        fxFlex="0 0 100%"
        [class.top-align]="source?.length"
        [ngClass]="{ 'mobile-view': isMobile | async }"
        [multiple]="multiple"
    >
        <ng-container *ngFor="let item of source">
            <mat-chip [matTooltip]="item.extra_info" class="chip-point" [value]="item.id" [selected]="item.selected">
                {{ item.label }}
            </mat-chip>
        </ng-container>
        <div *ngIf="source?.length" class="seperater"></div>
    </mat-chip-list>
</div>

<ng-template #activeFilterTemplate let-filter="filter">
    <mat-icon>{{ filter.icon }}</mat-icon>
    <span *ngFor="let item of filter.chips; let last = last">{{ item.label }}<span *ngIf="!last">,&nbsp;</span> </span>
</ng-template>
